import React from "react";
import Navbar from "../components/landing/LandingNavbar";
import Hero from "../components/landing/Hero";
import BentoGrid from "../components/landing/BentoGrid";
import Page4 from "../components/landing/Page4";
import Page5 from "../components/landing/Page5";
import Page7 from "../components/landing/Page7";
import Footer from "../components/landing/Footer";
import "../styles/landing/Global.css";

function Portfolio() {
  return (
    <>
      <Navbar />
      <Hero />
      <BentoGrid />
      <Page4 />
      <Page5 />
      <Page7 />
      <Footer />
    </>
  );
}

export default Portfolio;
